import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import 'hammerjs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr'; // For auth after login toast

import { CoreModule } from '@core/core.module';
import { CoreCommonModule } from '@core/common.module';
import { CoreSidebarModule, CoreThemeCustomizerModule } from '@core/components';

import { coreConfig } from 'app/app-config';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { MainModule } from './main/main.module';
import { AccessLogsForMMSService, AccountReceivableTypeService, AdminService, AnnouncementService, ApplicationConfigurationService, BankAccountService, BASE_PATH, BoardOfDirectorSignatoryService, BranchService, EFundService, EmployeeService, EventService, GAMService, GenderService, InvestmentApplicationFormService, LeadsService, PurchasesService, RegionService, ShareCapitalService, StandardEntryService, VoucherService, YoungCooperatorsService } from './api';

import { BASE_PATH as BASE_PATH_READ,ApplicantService } from './read-api';

import { BASE_PATH as REPORT_BASE_PATH} from './mms-report-api';

import { environment } from 'environments/environment';
import { BlockUIModule } from 'ng-block-ui';
import { AuthService } from './common/services/auth.service';
import { JwtModule } from '@auth0/angular-jwt';
import { ApiInterceptor } from './common/interceptor/api-interceptor';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { CountriesService } from './common/services/countries.service';
import { BASE_PATH  as IDENTITY_BASE_PATH} from 'app/identity-api';

import { BASE_PATH as BASE_PATH_REPORT_API} from 'app/report-api';
import { ProductsAndServicesService } from './api/api/productsAndServices.service';
import { BranchesDirectoryService } from './api/api/branchesDirectory.service';
import { RECAPTCHA_SETTINGS, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/pages/miscellaneous/error' //Error 404 - Page not found
  }
];


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: 'enabled', // Add options right here
      relativeLinkResolution: 'legacy'
    }),
    TranslateModule.forRoot(),

    //NgBootstrap
    NgbModule,
    ToastrModule.forRoot(),
    SweetAlert2Module.forRoot(),
    BlockUIModule.forRoot({
      message: 'Loading...'
    }),

    JwtModule.forRoot({
      config: {
        allowedDomains: ["localhost:4201"],
        tokenGetter: () => {
          return localStorage.getItem('access_token');
        },
      },
    }),

    // Core modules
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    CoreThemeCustomizerModule,
    RecaptchaModule,
    // App modules
    LayoutModule,
    MainModule
  ],
  // providers: [
  //   { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true }
  // ],
  providers: [ 
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    { provide: BASE_PATH, useValue: environment.apiUrl },

    { provide: BASE_PATH_READ, useValue: environment.readApiUrl },

    { provide: REPORT_BASE_PATH, useValue: environment.apiUrl },
    { provide: IDENTITY_BASE_PATH, useValue: environment.apiUrlForIdentity },
    { provide: BASE_PATH_REPORT_API, useValue: environment.reportApiUrl },

    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha.siteKey,
      } as RecaptchaSettings,
    },

    AuthService,
    AdminService,
    GenderService,
    LeadsService,
    CountriesService,
    EmployeeService,
    BranchService,
    BankAccountService,
    VoucherService,
    EventService,
    AnnouncementService,
    RegionService,
    ApplicationConfigurationService,
    ShareCapitalService,
    StandardEntryService,ApplicantService,
    InvestmentApplicationFormService,
    PurchasesService,
    AccountReceivableTypeService,
    BoardOfDirectorSignatoryService,
    ProductsAndServicesService,
    BranchesDirectoryService,
    YoungCooperatorsService,
    AccessLogsForMMSService,
    GAMService,
    EFundService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
